import { useRef } from 'react';
import {
  getBlockedCounterCoverButtonByDSOCodes,
  getBlockedCounterCoverButtonByDSOIds,
  shouldUseOfficeService,
} from '../../../../growthbook';

export const useIsCounterCoverBlocked = ({ id, code }) => {
  const blocked = useRef({
    codes: (getBlockedCounterCoverButtonByDSOCodes() || '').split(','),
    ids: (getBlockedCounterCoverButtonByDSOIds() || '').split(','),
  }).current;

  const isUseDSOStructure = useRef(shouldUseOfficeService()).current;

  return isUseDSOStructure ? blocked.ids.includes(id) : blocked.codes.includes(code);
};
